export const GET_PRODUCT_GROUP_COMPONENTS = {
  REQUEST: "GET_PRODUCT_GROUP_COMPONENTS_REQUEST",
  SUCCESS: "GET_PRODUCT_GROUP_COMPONENTS_SUCCESS",
  FAILURE: "GET_PRODUCT_GROUP_COMPONENTS_FAILURE",
};

export const PRODUCT_GROUP_COMPONENTS_LOADING =
  "PRODUCT_GROUP_COMPONENTS_LOADING";

export const RESET_PRODUCT_GROUP_COMPONENTS = "RESET_PRODUCT_GROUP_COMPONENTS";

export interface GetProductGroupComponentsPayload {
  productId: string;
  storeId: string;
  localeCode: string;
  categoryId: string;
  catalogId: string;
}

export interface GetProductGroupComponentsAction {
  type: typeof GET_PRODUCT_GROUP_COMPONENTS.REQUEST;
  payload: GetProductGroupComponentsPayload;
}

export interface ProductGroupComponentsLoadingAction {
  type: typeof PRODUCT_GROUP_COMPONENTS_LOADING;
  payload: {
    isLoading: boolean;
  };
}
export interface ProductGroupComponentsResponse {
  components: ProductGroupComponent[];
}

export interface ProductGroupComponent {
  productId: string;
  quantity?: number;
}
